/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Registration_HintInputs */

const en_admin_company_registration_hint = /** @type {(inputs: Admin_Company_Registration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When this toggle is enabled, new companies can register. When it is disabled, the registration form remains visible, but new company registrations are rejected by the server.`)
};

const de_admin_company_registration_hint = /** @type {(inputs: Admin_Company_Registration_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist der Schalter aktiviert, können sich neue Unternehmen anmelden. Ist er deaktiviert, bleibt das Anmeldeformular sichtbar, neue Unternehmensregistrierungen werden jedoch serverseitig abgelehnt.`)
};

/**
* | output |
* | --- |
* | "When this toggle is enabled, new companies can register. When it is disabled, the registration form remains visible, but new company registrations are reject..." |
*
* @param {Admin_Company_Registration_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_registration_hint = /** @type {((inputs?: Admin_Company_Registration_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Registration_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_registration_hint(inputs)
	return en_admin_company_registration_hint(inputs)
});